import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import Overlay from "../Overlay/Overlay";
import EmptyStatus from "../EmptyStatus/EmptyStatus";
import Status from "../Status/Status";
import React from "react";
import styles from "./EmptyOverlay.module.scss";

export interface EmptyOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    message?: string;
    children?: React.ReactNode;
}

const DefaultEmptyOverlay = (props: EmptyOverlayProps) => {
    const { className, message, children, ...rest } = props;

    return (
        <Overlay className={clsx(styles.emptyOverlay, className)} {...rest}>
            <EmptyStatus>
                {children || (message && <Status.Title>{message}</Status.Title>)}
            </EmptyStatus>
        </Overlay>
    );
};

const EmptyOverlay = createPluggable<EmptyOverlayProps>("deci.emptyOverlay", DefaultEmptyOverlay);

export default Object.assign(EmptyOverlay, {
    Graphic: Status.Graphic,
    Title: Status.Title,
    Content: Status.Content,
});

